export enum MaintenanceItemTypeEnum {
  Component = 0,
  ComponentGroup = 1,
}
